
import { SectionModel } from './section.model';

export class PermissionModel {
  constructor(public id: number = null,
              public label: string = null,
              public code: string = null,
              public priority: number = null,
              public sectionId: number = null,
              public section: SectionModel = null,
              public description: string = null) {
  }

  public fromJSON(json) {
    for (let propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
